import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

export const selectIsMarketYoyGrowthSaving = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => state.isSaving
)
